import './styles.css';

const Preloader = () => {
  return (
    <div id="preloader">
        <div id="loading">
        </div>
    </div>
  )
}

export default Preloader